import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RoundsRoutingModule } from './rounds-routing.module';
import { RoundsListComponent } from './rounds-list/rounds-list.component';
import { RoundsCreateComponent } from './rounds-create/rounds-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [RoundsListComponent, RoundsCreateComponent],
  imports: [
    CommonModule,
    RoundsRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class RoundsModule { }
